<template>
  <div :class="$style.head">
    <div :class="$style.title">Реестр наблюдений</div>
    <div :class="$style.right">
      <div :class="$style.filters" @click="handleExport">
        Выгрузить
        <img src="/icons/analytics/donwload.svg" alt="" />
      </div>
      <div :class="$style.filters">
        <img
          src="/icons/analytics/filters.svg"
          alt=""
          @click="$emit('openFilter')"
        />
        <img
          v-if="isFilterActive"
          src="/icons/common/cross-black.svg"
          alt=""
          @click="$emit('clearFilter')"
        />
      </div>
      <div :class="$style.remove" @click="showConfirmModal">
        Удалить не подтвержденные элементы
      </div>
    </div>
  </div>
  <DeleteConfirmModal
    :isOpen="isConfirmModalOpen"
    :count="unverifiedCount"
    @close="closeConfirmModal"
    @confirm="confirmDelete"
  />
</template>

<script>
import DeleteConfirmModal from "./DeleteConfirmModal.vue";
import Repository from "@/repository";

export default {
  name: "AnalyticsHeader",
  components: {
    DeleteConfirmModal,
  },
  props: {
    isFilterActive: {
      type: Boolean,
      default: false,
    },
    unverifiedCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isConfirmModalOpen: false,
    };
  },
  methods: {
    showConfirmModal() {
      if (this.unverifiedCount > 0) {
        this.isConfirmModalOpen = true;
      }
    },
    closeConfirmModal() {
      this.isConfirmModalOpen = false;
    },
    confirmDelete() {
      this.$emit("deleteNotVerified");
      this.closeConfirmModal();
    },
    async handleExport() {
      this.$store.commit("setLoadersCount", "+");
      const { value, error } = await Repository.Supervision.export({
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      });
      this.$store.commit("setLoadersCount", "-");
      if (error) {
        console.error("Ошибка при экспорте:", error);
        // Можно добавить уведомление об ошибке
      }
    },
  },
  emits: ["openFilter", "clearFilter", "deleteNotVerified"],
};
</script>

<style lang="scss" module>
.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding: 0 1.5rem;
  .title {
    font-weight: 700;
    font-size: 1.25rem;
  }
  .right {
    display: flex;
    align-items: center;
    gap: 1rem;
    .filters {
      background-color: $bg-white;
      border-radius: 2rem;
      padding: 0 1rem;
      display: flex;
      align-items: center;
      gap: 1rem;
      height: 2rem;
      cursor: pointer;
    }
    .remove {
      color: $red;
      cursor: pointer;
    }
  }
}
</style>

